import { createContext } from 'react';

export interface DreamComponentsContextType {
  responsiveImagesEnabled?: boolean;
  responsiveImagesBreakpoints?: number[];
}

export const DREAM_COMPONENTS_CONTEXT_DEFAULT_VALUES: DreamComponentsContextType = {
  responsiveImagesEnabled: false,
  responsiveImagesBreakpoints: [360, 430],
};

export const DreamComponentsContext = createContext<DreamComponentsContextType | undefined>(undefined);
